module.exports = __webpack_public_path__ + "static/media/flex-arrow.a1a878fc.svg";